"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .64-.13 1.25-.35 1.82l1.5 1.5c.54-.99.85-2.12.85-3.32 0-2.22-1.03-4.19-2.64-5.47L15 2H9l-.96 3.21 2.14 2.14C10.75 7.13 11.36 7 12 7M2.81 2.81 1.39 4.22l4.46 4.46C5.31 9.67 5 10.8 5 12c0 2.22 1.03 4.19 2.64 5.47L9 22h6l.96-3.21 3.82 3.82 1.41-1.41zM12 17c-2.76 0-5-2.24-5-5 0-.64.13-1.25.35-1.82l6.47 6.47c-.57.22-1.18.35-1.82.35"
}), 'WatchOff');